import { render, staticRenderFns } from "./service-info.vue?vue&type=template&id=ddaabbc0&scoped=true"
import script from "./service-info.vue?vue&type=script&lang=js"
export * from "./service-info.vue?vue&type=script&lang=js"
import style0 from "./service-info.vue?vue&type=style&index=0&id=ddaabbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaabbc0",
  null
  
)

export default component.exports